"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityProvider = exports.SpeakerDiarizationMode = void 0;
/**
 * The speaker diarization mode
 */
var SpeakerDiarizationMode;
(function (SpeakerDiarizationMode) {
    SpeakerDiarizationMode["None"] = "None";
    SpeakerDiarizationMode["Identity"] = "Identity";
    SpeakerDiarizationMode["Anonymous"] = "Anonymous";
})(SpeakerDiarizationMode = exports.SpeakerDiarizationMode || (exports.SpeakerDiarizationMode = {}));
/**
 * The identity provider
 */
var IdentityProvider;
(function (IdentityProvider) {
    IdentityProvider["CallCenter"] = "CallCenter";
})(IdentityProvider = exports.IdentityProvider || (exports.IdentityProvider = {}));

//# sourceMappingURL=SpeakerDiarization.js.map
